<template>
  <!-- 积分记录 -->
  <div class="sign_record">
    <!-- <myNav title="记录" /> -->
    <ul class="record_content">
      <van-pull-refresh v-model="state.refreshLoading" @refresh="onRefresh">
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <li
            v-for="(item, index) in state.logList"
            :key="index + item.time + 'record'"
          >
            <div class="left">
              <p>{{ item.from }}</p>
              <p>
                获取时间：<span>{{ item.time }}</span>
              </p>
            </div>
            <p class="right">+{{ item.number }}积分</p>
          </li>
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>
<script setup>
import { onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { dateChangeFomat2 } from "@/utils/date";
import { getQueryString } from "../../../utils/location";

const store = useStore();
const state = reactive({
  loading: true,
  finished: false,
  refreshLoading: false,
  uid: getQueryString("uid"),
  logList: [],
});

onMounted(() => {
  console.log("signRecord--onMounted");
  getGoldLog();
});
const onRefresh = async () => {
  state.refreshLoading = true;
  state.finished = false;
  page = 1;
  await getGoldLog();
};
const onLoad = async () => {
  await getGoldLog();
};

import { getLog } from "@/api/yztask";
var page = 1;
const getGoldLog = async () => {
  try {
    let res = await getLog({ uid: state.uid, pagecode: page });
    if (page == 1) {
      state.logList = [];
    }
    //
    state.refreshLoading && (state.refreshLoading = false);
    // console.log("getLog接口返回的数据-----------------", res.data.data);
    if (res.data.code == 1) {
      let newData =
        res.data.data.lists &&
        res.data.data.lists.map((item) => {
          item.time = dateChangeFomat2(item.time);
          return item;
        });
      state.logList = state.logList.concat(newData);

      // 判断是否还有下一页
      let totalpage = res.data.data.total_page;
      if (page < totalpage) {
        page++;
        state.loading = true;
      } else {
        state.finished = true;
      }
    } else {
      state.finished = true;
    }
    state.loading = false;
  } catch (error) {
    console.log(error);
    state.loading = false;
  }
};
</script>
<style scoped>
.sign_record {
  padding-top: 30px;
  height: 100vh;
  background-color: #f7f7f7;
  overflow: auto;
}
.record_content {
  padding: 0 32px;
  min-height: 100vh;
}
.record_content li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 134px;
  background-color: #fff;
  margin-bottom: 20px;
  padding: 0 32px 0 24px;
  border-radius: 16px;
  color: #333;
}
.record_content li .left p:nth-of-type(1) {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 12px;
}
.record_content li .left p:nth-of-type(2) {
  font-size: 24px;
}
.record_content li .left p:nth-of-type(2) span {
  color: #666666;
}
.record_content li .right {
  font-size: 32px;
  color: #FFAE27;
  font-weight: 500;
}
</style>
